export class AmlWorkspace{
  constructor(
    public resourceGroupId: any = '',
    public resourceGroupName: any = '',
    public locationId: any = '',
    public locationName: any = '',
    public workspace: any = '',
    public workspaceEdition: any = '',
    public createdBy: any = '',
    public keyVaultId: any = '',
    public keyVaultName: any = '',
    public storageAccountId: any = '',
    public storAcctName: any = '',
    public containerRegistryId: any = '',
    public containerRegistryName: any = '',
    public applicationInsightId: any = '',
    public applicationInsightName: any = '',
  ) { } 
}

